import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';

export function getMemberBlackList(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/black_list/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberBlackList.js